module.exports = __webpack_public_path__ + "img/reference25.c73282f6.jpg";